var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "content-processos" }, [
      _c(
        "div",
        { staticClass: "processos-main" },
        [
          _c(
            "el-card",
            { staticClass: "card-container", attrs: { shadow: "hover" } },
            [
              _c("b", [_vm._v("Solicitar liberação de cláusula resolutiva:")]),
              _c(
                "div",
                { staticClass: "dados-processo" },
                [
                  _c("span", [
                    _vm._v(
                      "Selecione o processo que deseja solicitar liberação de cláusula resolutiva:"
                    )
                  ]),
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        label: this.isMaranhao,
                        disabled: !this.isMaranhao
                      },
                      model: {
                        value: _vm.radioValue,
                        callback: function($$v) {
                          _vm.radioValue = $$v
                        },
                        expression: "radioValue"
                      }
                    },
                    [_vm._v("Processo SiCARF")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: !this.isMaranhao },
                      model: {
                        value: _vm.radioValue,
                        callback: function($$v) {
                          _vm.radioValue = $$v
                        },
                        expression: "radioValue"
                      }
                    },
                    [_vm._v("Processo Físico")]
                  ),
                  _c(
                    "validation-observer",
                    {
                      ref: "validation",
                      staticClass: "align",
                      attrs: { tag: "form" }
                    },
                    [
                      this.isMaranhao
                        ? _c(
                            "el-col",
                            { staticStyle: { flex: "1" }, attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name: "Tipo Título"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label:
                                                "Selecione o tipo de título:"
                                            }
                                          }),
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                clearable: "clearable",
                                                filterable: "filterable",
                                                name: "tipo titulo",
                                                "collapse-tags": "collapse-tags"
                                              },
                                              model: {
                                                value: _vm.tipoTitulo,
                                                callback: function($$v) {
                                                  _vm.tipoTitulo = $$v
                                                },
                                                expression: "tipoTitulo"
                                              }
                                            },
                                            _vm._l(_vm.tiposTitulo, function(
                                              item
                                            ) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  label: item.value,
                                                  value: item.value
                                                }
                                              })
                                            }),
                                            1
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  168110490
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { staticStyle: { flex: "1" }, attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: _vm.getRulesNumeroProcesso(),
                              name: "Número Processo"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("app-label", {
                                          attrs: {
                                            label:
                                              "Insira o número do processo:",
                                            required: !!_vm.getRulesNumeroProcesso()
                                          }
                                        }),
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticStyle: {
                                              "margin-left": "3%"
                                            },
                                            attrs: {
                                              effect: "light",
                                              placement: "right"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    "O número do processo se encontra no título do imóvel"
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-info"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c("el-input", {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { name: "Número Processo" },
                                      model: {
                                        value: _vm.numeroProcesso,
                                        callback: function($$v) {
                                          _vm.numeroProcesso = $$v
                                        },
                                        expression: "numeroProcesso"
                                      }
                                    }),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticStyle: { flex: "1" }, attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: _vm.getRulesNumeroProcesso(),
                              name: "Número Título Dominial"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-label", {
                                      attrs: {
                                        label:
                                          "Insira o número do Título do Domínio:",
                                        required: !!_vm.getRulesNumeroProcesso()
                                      }
                                    }),
                                    _c("el-input", {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { name: "Número Título Dominial" },
                                      model: {
                                        value: _vm.numeroTituloDominial,
                                        callback: function($$v) {
                                          _vm.numeroTituloDominial = $$v
                                        },
                                        expression: "numeroTituloDominial"
                                      }
                                    }),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "Data de emissão do documento"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("app-label", {
                                          attrs: {
                                            label:
                                              "Data de emissão do documento:"
                                          }
                                        }),
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticStyle: {
                                              "margin-left": "3%"
                                            },
                                            attrs: {
                                              effect: "light",
                                              placement: "right"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    "Data de emissão do título de domínio, escritura pública de compra e venda ou outro documento"
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-info"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c("el-date-picker", {
                                      directives: [
                                        {
                                          name: "mask",
                                          rawName: "v-mask",
                                          value: "##/##/####",
                                          expression: "'##/##/####'"
                                        }
                                      ],
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      staticStyle: { width: "inherit" },
                                      attrs: {
                                        type: "date",
                                        name: "Data de emissão do documento",
                                        placeholder: "Selecione",
                                        format: "dd/MM/yyyy",
                                        "picker-options": _vm.pickerOptions
                                      },
                                      model: {
                                        value: _vm.dataEmissaoTituloDominial,
                                        callback: function($$v) {
                                          _vm.dataEmissaoTituloDominial = $$v
                                        },
                                        expression: "dataEmissaoTituloDominial"
                                      }
                                    }),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("app-buttons-cadastro", {
                staticClass: "alinhar",
                attrs: { showButtonProximo: true, isPrimeiroPasso: true },
                on: {
                  cancelar: function($event) {
                    return _vm.cancelar()
                  },
                  proximo: function($event) {
                    return _vm.proximo()
                  }
                }
              }),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "Atenção",
                    visible: _vm.dialogVisible,
                    width: "30%",
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      "Prezado usuário, você não pode solicitar liberação de cláusulas resolutivas para este processo pois ainda "
                    ),
                    _c("b", [_vm._v("não cumpriu")]),
                    _vm._v(" o prazo de 10 (dez) anos como Titular do Imóvel")
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.dialogVisible = false
                            }
                          }
                        },
                        [_vm._v("Ok")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d2f0872", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d2f0872","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/liberacao/EscolhaTipoProcesso.vue
// module id = null
// module chunks = 